import React from "react";
import Hero from "../components/Hero";
import ValueBar from "../components/ValueBar";
import FeaturedProduct from "../components/FeaturedProduct";
import OurStory from "../components/OurStory";
import Journey from "../components/Journey";
import Roastery from "../components/Roastery";
import Testimonials from "../components/Testimonials";
import BrewGuide from "../components/BrewGuide";
import Certifications from "../components/Certifications";
import InstagramFeed from "../components/InstagramFeed";
import Partners from "../components/Parters";
import SubscribeBanner from "../components/SubscribeBanner";
import ClosingCTA from "../components/ClosingCTA";

function Home() {
  return (
    <main className="bg-cream">
      <Hero />
      <ValueBar />
      <FeaturedProduct />
      <OurStory />
      <Journey />
      <Roastery />
      <Testimonials />
      <BrewGuide />
      <Certifications />
      <Partners />
      <InstagramFeed />
      <SubscribeBanner />
      <ClosingCTA />
    </main>
  );
}

export default Home;
